/**
 * Error Handler Utility
 * Centralized error handling for API responses
 */

/**
 * Handle API errors and return formatted error message
 * @param {Error} error - Error object from axios
 * @param {string} defaultMessage - Default error message if none found
 * @returns {Error} Formatted error
 */
export const handleApiError = (error, defaultMessage = 'Something went wrong') => {
  if (error.response) {
    // Server responded with error
    const data = error.response.data;
    // data.error may be a boolean flag (true/false), so only use it if it's a string
    const errorMessage =
      (typeof data.error === 'string' ? data.error : null) ||
      data.message ||
      data.detail ||
      defaultMessage;
    return new Error(errorMessage);
  } else if (error.request) {
    // Request made but no response
    return new Error('Network error. Please check your connection.');
  } else {
    // Error in request setup
    return new Error('An error occurred. Please try again.');
  }
};

export default handleApiError;
